// extracted by mini-css-extract-plugin
export var cardTitle = "_hr-1";
export var commentBubble = "_hr-e";
export var commentForm = "_hr-a";
export var commentInput = "_hr-b";
export var commentLabel = "_hr-d";
export var commentPrompt = "_hr-9";
export var csatCard = "_hr-0";
export var feedbackSection = "_hr-7";
export var starDisabled = "_hr-6";
export var starEmpty = "_hr-5";
export var starFilled = "_hr-4";
export var starWrapper = "_hr-3";
export var starsContainer = "_hr-2";
export var submittedComment = "_hr-c";
export var thankYouText = "_hr-8";